export const adCampaignsQueries = {
  all: ['adCampaigns' as const],
  adCampaignInfo: () => [...adCampaignsQueries.all, 'adCampaignInfo'],
  selfServeSponsorRequest: (selfServeSponsorRequestId: number | null) => [
    ...adCampaignsQueries.all,
    'selfServeSponsorRequest',
    selfServeSponsorRequestId,
  ],
};
